import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function ServicesPreview() {
  const { t } = useTranslation();

  const cards = [
    {
      title: t('services.cards.sprayFoam.title'),
      desc: t('services.cards.sprayFoam.desc'),
      image: 'https://storage.readdy-site.link/project_files/95272ccd-89f8-41e5-a90f-f2c2b48cc48a/a4e193dd-1e7b-4294-90bb-6097655ba965_compressed_magnific_create-an-ultrarealistic-_0pzazHaTfW.webp',
      icon: 'ri-window-line',
      service: 'Window%20Screens',
    },
    {
      title: t('services.cards.battRoll.title'),
      desc: t('services.cards.battRoll.desc'),
      image: 'https://storage.readdy-site.link/project_files/95272ccd-89f8-41e5-a90f-f2c2b48cc48a/696abc18-c46e-42f5-8b40-ec4c7f1f3b60_compressed_magnific_create-an-ultrarealistic-_xg565cOjfW.webp',
      icon: 'ri-door-line',
      service: 'Screen%20Repair',
    },
    {
      title: t('services.cards.cellulose.title'),
      desc: t('services.cards.cellulose.desc'),
      image: 'https://storage.readdy-site.link/project_files/95272ccd-89f8-41e5-a90f-f2c2b48cc48a/6be02f1d-3079-4a59-ab1e-e705c8cac521_compressed_magnific_reframe-this-exact-photog_UyLGgAjwny.webp',
      icon: 'ri-tools-line',
      service: 'Door%20Screens',
    },
  ];

  return (
    <section className="py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 items-center mb-14">
          <div className="flex-1">
            <span className="text-primary-500 text-xs font-bold uppercase tracking-[0.25em]">{t('services.label')}</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-50 mt-3 leading-tight max-w-md">
              {t('services.title')}
            </h2>
            <p className="text-foreground-400 mt-4 text-sm leading-relaxed max-w-sm">
              {t('services.description')}
            </p>
            <div className="inline-flex items-center gap-3 bg-background-100 border border-primary-500/30 text-foreground-50 px-6 py-3.5 rounded-xl mt-7">
              <i className="ri-map-pin-line text-primary-500 text-xl w-6 h-6 flex items-center justify-center" />
              <div>
                <span className="text-2xl font-extrabold text-primary-500">{t('services.areaBadge')}</span>
                <span className="text-foreground-50 font-semibold text-sm ml-2">{t('services.areaLabel')}</span>
                <p className="text-foreground-400 text-xs mt-0.5">{t('services.areaSub')}</p>
              </div>
            </div>
          </div>
          <div className="flex-1 relative">
            <div className="relative w-full h-[420px] rounded-2xl overflow-hidden">
              <img
                alt="The Screen Squad screen repair team in action"
                className="w-full h-full object-cover object-center"
                src="https://storage.readdy-site.link/project_files/95272ccd-89f8-41e5-a90f-f2c2b48cc48a/e0edb366-3f95-4f2b-bbc8-b57aa9a8f275_compressed_magnific_reframe-this-exact-photog_62yD4NJiJO.webp"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
            </div>
            <div className="absolute bottom-5 right-5 flex flex-col gap-3 w-64">
              <div className="bg-background-100/95 backdrop-blur-sm rounded-xl px-4 py-3 flex items-start gap-3 border border-primary-500/20">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500/15 rounded-lg shrink-0 mt-0.5">
                  <i className="ri-shield-check-line text-primary-500 text-base w-5 h-5 flex items-center justify-center" />
                </div>
                <div>
                  <h4 className="text-foreground-50 font-bold text-xs leading-tight">{t('services.overlay.reliable')}</h4>
                  <p className="text-foreground-400 text-[11px] mt-0.5 leading-relaxed">{t('services.overlay.reliableDesc')}</p>
                </div>
              </div>
              <div className="bg-background-100/95 backdrop-blur-sm rounded-xl px-4 py-3 flex items-start gap-3 border border-primary-500/20">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500/15 rounded-lg shrink-0 mt-0.5">
                  <i className="ri-file-list-3-line text-primary-500 text-base w-5 h-5 flex items-center justify-center" />
                </div>
                <div>
                  <h4 className="text-foreground-50 font-bold text-xs leading-tight">{t('services.overlay.freeQuotes')}</h4>
                  <p className="text-foreground-400 text-[11px] mt-0.5 leading-relaxed">{t('services.overlay.freeQuotesDesc')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
          <h3 className="text-xl font-bold text-foreground-50">{t('services.cardTitle')}</h3>
          <p className="text-foreground-400 text-sm max-w-md">{t('services.cardDesc')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((card, i) => (
            <div key={i} className="group bg-background-100 rounded-2xl overflow-hidden border border-white/5 hover:border-primary-500/40 transition-all duration-700 hover:-translate-y-1">
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  alt={card.title}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  src={card.image}
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/50 transition-all duration-500 flex items-center justify-center">
                  <Link
                    to={`/contact?service=${card.service}`}
                    className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-bold px-6 py-3 rounded-full text-sm transition-all duration-300 cursor-pointer opacity-0 group-hover:opacity-100 translate-y-3 group-hover:translate-y-0 whitespace-nowrap"
                  >
                    {t('services.cards.sprayFoam.cta')}
                    <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
                  </Link>
                </div>
              </div>
              <div className="p-6">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-500/15 rounded-xl mb-4">
                  <i className={`${card.icon} text-primary-500 text-lg w-6 h-6 flex items-center justify-center`} />
                </div>
                <h3 className="text-foreground-50 font-bold text-base mb-2">{card.title}</h3>
                <p className="text-foreground-400 text-sm leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/services"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-black font-semibold px-10 py-4 rounded-full text-sm transition-colors cursor-pointer"
          >
            {t('services.cta')}
            <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center" />
          </Link>
        </div>
      </div>
    </section>
  );
}